"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateIdsMap = void 0;
exports.TemplateIdsMap = {
    FULL_TIME_RESULT_1X2: 1,
    WHICH_TEAM_WINS_THE_REST_OF_MATCH: 7,
    GOAL: 8,
    DOUBLE_CHANCE: 10,
    DRAW_NO_BET: 11,
    COMPETITOR1_NO_BET: 12,
    COMPETITOR2_NO_BET: 13,
    HANDICAP_VALUE: 14,
    HANDICAP: 16,
    TOTAL: 18,
    HANDICAP_1ST_HALF: 66,
    HANDICAP_2ND_HALF: 88,
    TOTAL_1ST_HALF: 68,
    TOTAL_2ND_HALF: 90,
    TOTAL_1ST_HALF_COMPETITOR1: 69,
    TOTAL_1ST_HALF_COMPETITOR2: 70,
    TOTAL_2ND_HALF_COMPETITOR1: 91,
    TOTAL_2ND_HALF_COMPETITOR2: 92,
    COMPETITOR1_TOTAL: 19,
    COMPETITOR2_TOTAL: 20,
    ODD_EVEN: 26,
    BOTH_TEAMS_TO_SCORE: 29,
    COMPETITOR2_CLEAN_SHEET: 32,
    BOTH_TEAMS_TO_SCORE_1X2: 35,
    TOTAL_1X2: 37,
    CORRECT_SCORE: 45,
    CORRECT_SCORE_V2: 431,
    CORRECT_SCORE_SCOREVALUE: 41,
    CORRECT_SCORE_SCOREVALUE_V2: 401,
    CORRECT_SCORE_1ST_HALF: 81,
    CORRECT_SCORE_1ST_HALF_SCOREVALUE: 402,
    CORRECT_SCORE_2ND_HALF: 98,
    PERIODNUMBER_PERIOD_CORRECT_SCORE: 456,
    PERIODNUMBER_PERIOD_TOTAL: 446,
    PERIODNUMBER_PERIOD_HANDICAP: 460,
    SETNUMBER_SET_CORRECT_SCORE: 207,
    SETNUMBER_SET_POINT_HANDICAPS: 309,
    SETNUMBER_SET_TOTAL_POINTS: 310,
    DOUBLE_CHANCE_BOTH_TEAMS_TO_SCORE: 546,
    DOUBLE_CHANCE_TOTAL: 547,
    COMPETITOR1_TO_WIN: 880,
    COMPETITOR2_TO_WIN: 879,
    ANY_TEAM_TO_WIN: 881,
    OVERTIME_TOTAL: 116,
    OVERTIME_HANDICAP: 117,
    OVERTIME_1ST_HALF_HANDICAP: 120,
    TOTAL_CORNERS: 166,
    GAME_HANDICAP: 187,
    GAME_HANDICAP_SETNUMBER: 203,
    TOTAL_GAMES: 189,
    TOTAL_GAMES_COMPETITOR1: 190,
    TOTAL_GAMES_COMPETITOR2: 191,
    HANDICAP_INCL_OVERTIME: 223,
    TOTAL_INCL_OVERTIME: 225,
    HANDICAP_2ND_HALF_INCL_OVERTIME: 231,
    TOTAL_2ND_HALF_INCL_OVERTIME: 232,
    POINT_HANDICAP: 237,
    TOTAL_POINTS: 238,
    GAME_GAMENUMBER_POINT_HANDICAP: 246,
    GAME_GAMENUMBER_TOTAL_POINTS: 247,
    HANDICAP_INCL_EXTRA_INNINGS: 256,
    TOTAL_INCL_EXTRA_INNINGS: 258,
    COMPETITOR2_TOTAL_INCL_EXTRA_INNINGS: 261,
    COMPETITOR1_TOTAL_INCL_EXTRA_INNINGS: 260,
    INNINGS_1TO5_HANDICAP: 275,
    INNINGS_1TO5_TOTAL: 276,
    INNINGS_1TO5_COMPETITOR1_TOTAL: 277,
    INNINGS_1TO5_COMPETITOR2_TOTAL: 278,
    INNINGS_FROMVALUE_TOVALUE_TOTAL: 284,
    INNINGS_FROMVALUE_TOVALUE_COMPETITOR1_TOTAL: 285,
    INNINGS_FROMVALUE_TOVALUE_COMPETITOR2_TOTAL: 286,
    INNINGS_FROMVALUE_TOVALUE_HANDICAP: 744,
    INNINGNUMBER_INNING_TOTAL: 288,
    INNINGNUMBER_INNING_HANDICAP: 746,
    TOTAL_SCORELESS_INNINGS: 740,
    HANDICAP_INCL_OVERTIME_AND_PENALTIES: 410,
    TOTAL_INCL_OVERTIME_AND_PENALTIES: 412,
    COMPETITOR1_TOTAL_INCL_OVERTIME_AND_PENALTIES: 414,
    COMPETITOR2_TOTAL_INCL_OVERTIME_AND_PENALTIES: 415,
    COMPETITOR1_TOTAL_INCL_OVERTIME: 227,
    COMPETITOR2_TOTAL_INCL_OVERTIME: 228,
    TOTAL_OVER_EXACT_UNDER: 297,
    QUARTERNUMBER_QUARTER_COMPETITOR1_TOTAL: 756,
    QUARTERNUMBER_QUARTER_COMPETITOR2_TOTAL: 757,
    QUARTERNUMBER_QUARTER_TOTAL: 236,
    QUARTERNUMBER_QUARTER_HANDICAP: 303,
    WINNER_INCL_OVERTIME: 219,
    WINNER: 186,
    WINNER_INCL_EXTRA_INNINGS: 251,
    SETNUMBER_SET_WINNER: 202,
    HANDICAP_CORNER: 165,
    HANDICAP_CORNER_1ST_HALF: 176,
    TOTAL_CORNERS_1ST_HALF: 177,
};
//# sourceMappingURL=templateIdsMap.js.map